import { z } from "zod";
import {
  isEndDateAfterStartDate,
  isValidDateString,
} from "@/utils/date-vigencia";

export const regionalSubstitutionFormSchema = z
  .object({
    regional_id: z
      .number({
        required_error: "O regional é obrigatório",
        invalid_type_error: "O regional é obrigatório",
      })
      .int()
      .positive("O regional é obrigatório"),
    user_id: z
      .string({ required_error: "O gerente substituto é obrigatório" })
      .uuid("Selecione um gerente substituto válido"),
    initial_term: z
      .string()
      .min(1, "O início da vigência é obrigatório")
      .refine(isValidDateString, "O início da vigência é uma data inválida"),
    final_term: z
      .string()
      .min(1, "O fim da vigência é obrigatório")
      .refine(isValidDateString, "O fim da vigência é uma data inválida"),
  })
  .refine(
    (data) => isEndDateAfterStartDate(data.initial_term, data.final_term),
    {
      message: "O fim da vigência deve ser posterior ao início",
      path: ["final_term"],
    },
  );

export type RegionalSubstitutionFormData = z.infer<
  typeof regionalSubstitutionFormSchema
>;
